import { ArgsType, Field } from '@nestjs/graphql'

@ArgsType()
export class GetAdminStatsArgs {
  @Field({ nullable: true })
  fromDate?: Date

  @Field({ nullable: true })
  toDate?: Date
}
